<template>
  <div class="page-container">
    <div>
      <el-button v-if="!noContent" type="primary" :disabled="addBtnLoading" @click="addOrUpdateHandle()">Add Office Address</el-button>
    </div>
    <div class="el-list protocols-wrapper">
      <el-row v-loading="dataListLoading" :gutter="30">
        <el-col v-if="noContent">
          <el-empty description=" ">
            <el-button type="primary" @click="addOrUpdateHandle()">Add Office Address</el-button>
          </el-empty>
        </el-col>
        <template v-if="!noContent">
          <el-col :span="6" v-for="item in dataList" :key="item.id">
            <el-card shadow="nerver" :body-style="{ padding: '0px' }" class="mt16 relative">
              <div class="module-item">
                <div class="module-desc">
                  <p class="item-wrap">
                    <span class="wd86 item-label">Entity type:</span>
                    <span class="item-content">
                      {{ entityTypes.find(el => el.value == item.type).title ? entityTypes.find(el => el.value == item.type).title : "" }}
                    </span>
                  </p>
                  <p class="item-wrap">
                    <span class="wd86 item-label">{{ isMultiLineAddressCountry(item.country) ? "Address 1:" : "Address:" }}</span>
                    <span class="item-content">{{ isMultiLineAddressCountry(item.country) ? item.addressLine1 : item.address }}</span>
                  </p>
                  <p class="item-wrap">
                    <span class="wd86 item-label">Country:</span>
                    <span class="item-content">{{ countryFormat(item.country) }}</span>
                  </p>
                  <p class="item-wrap">
                    <span class="wd86 item-label">Supplier:</span>
                    <span class="item-content">{{ item.supplier?.abbr || "" }}</span>
                  </p>
                  <p class="item-wrap">
                    <span class="wd86 item-label">Status:</span>
                    <span class="item-content" v-if="item.status == 0">Disable</span>
                    <span class="item-content" v-if="item.status == 1">Enable</span>
                  </p>
                  <p class="item-wrap">
                    <span class="wd86 item-label">Update:</span>
                    <span class="item-content">{{ item.updateTime }}</span>
                  </p>
                </div>
              </div>
              <ul class="el-card-actions">
                <li style="width: 50%" @click="deleteHandle(item.id)">
                  <svg-icon name="delete" class="fs16"></svg-icon>
                </li>
                <li style="width: 50%" @click="addOrUpdateHandle(item)">
                  <svg-icon name="edit" class="fs16"></svg-icon>
                </li>
              </ul>
            </el-card>
          </el-col>
        </template>
      </el-row>
    </div>

    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update ref="addOrUpdate" :supplierList="supplierList" @refreshDataList="getDataList"></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from "./modal/AddOrUpdate";
import formatterMixin from "@/mixins/formatterMixin";
import { mapState } from "vuex";
export default {
  mixins: [formatterMixin],
  components: {
    AddOrUpdate,
  },
  data() {
    return {
      dataForm: {},
      dataList: [],
      supplierList: [],
      dataListLoading: false,
      addBtnLoading: false,
    };
  },
  computed: {
    ...mapState("constant", ["countryList", "entityTypes"]),
    noContent() {
      return this.dataList.length === 0;
    },
  },
  methods: {
    // 是否为多行地址国家（与 AddOrUpdate.vue 中 isMultiLineAddressCountry 逻辑保持一致）
    isMultiLineAddressCountry(country) {
      const SUPPORTED = ["Malaysia"]; // 后期可新增 "Virgin Islands, British", "Cayman Islands"
      return SUPPORTED.includes(country);
    },
    // 获取供应商列表
    getSupplierList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/supplier")
          .then(res => {
            this.supplierList = res.data || [];
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取数据列表
    async getDataList() {
      this.dataListLoading = true;
      this.$http
        .get("/admin/stRegisteredOfficeAddressManage/getList")
        .then(res => {
          const resData = res.data || [];
          this.dataList = resData;
        })
        .catch(err => {})
        .finally(() => {
          this.dataListLoading = false;
        });
    },
    // 新增 / 修改
    addOrUpdateHandle(data) {
      this.$refs.addOrUpdate.init(data);
    },
    // 删除
    async deleteHandle(id) {
      await this.$confirm(`Delete this Address. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      this.$http
        .post(`/admin/stRegisteredOfficeAddressManage/${id}/delete`)
        .then(res => {
          this.$message({
            message: "success",
            type: "success",
            duration: 1500,
            onClose: () => this.getDataList(),
          });
        })
        .catch(err => {});
    },
  },
  async activated() {
    try {
      this.addBtnLoading = true;
      this.dataListLoading = true;
      await this.getSupplierList();
    } catch (error) {
    } finally {
      this.addBtnLoading = false;
      this.getDataList();
    }
  },
};
</script>

<style lang="scss" scoped></style>
